import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AppConfig from "../../../../../config/AppConfig";
import {AppIconThumbnail} from "../../../../../components/BaseComponents/AppIconThumbnail";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";
import {
    EXPENSE_STATUSES,
    EXPENSE_STATUS_BADGE_CLASSES,
    EXPENSE_STATUS_WAITING_REVIEW,
    EXPENSE_TYPES
} from "./ExpensesConstants";

export default class ExpensesListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getStatusInfo = status => ({
        label: EXPENSE_STATUSES[status] || EXPENSE_STATUSES[EXPENSE_STATUS_WAITING_REVIEW],
        className: EXPENSE_STATUS_BADGE_CLASSES[status] || EXPENSE_STATUS_BADGE_CLASSES[EXPENSE_STATUS_WAITING_REVIEW]
    });

    handleOpenClick = _ => {
        if (this.props.onOpen) {
            this.props.onOpen(this.props.item);
        }
    }

    render() {
        const item = this.props.item || {};
        const staff = this.props.staff || {};
        const negozio = staff.negozio || item.negozio || null;
        const negozioIconUrl = negozio?.id_negozio
            ? `${AppConfig.webServerUrl}/api/negozio/${negozio.id_negozio}/logoIcon/50`
            : null;
        const statusInfo = this.getStatusInfo(item.status);
        const updatedAt = item.updated_at ? moment(item.updated_at).format("DD/MM/YYYY HH:mm") : "-";
        const amount = item.amount ? `€ ${item.amount}` : "-";
        const typeLabel = EXPENSE_TYPES[item.type] || EXPENSE_TYPES.generic;

        return (
            <button
                type={"button"}
                className={"list-group-item list-group-item-action text-left"}
                onClick={this.handleOpenClick}
            >
                <div className={"d-flex justify-content-between align-items-start"}>
                    <div className={"d-flex align-items-center"}>
                        <AppIconThumbnail size={"32px"} src={negozioIconUrl} className={"mr-2"}/>
                        <div className={"font-weight-bold"}>{negozio?.nome || "Attivita'"}</div>
                    </div>
                    <span className={statusInfo.className}>{statusInfo.label}</span>
                </div>
                <div className={"text-muted small mt-1 d-flex align-items-center justify-content-between"}>
                    <span>{typeLabel} - {amount}</span>
                    <span className={"d-flex align-items-center"}>
                        <FaSolidIcon name={"clock"} className={"mr-1"}/>
                        {updatedAt}
                    </span>
                </div>
            </button>
        );
    }
}

ExpensesListItem.propTypes = {
    item: PropTypes.object,
    staff: PropTypes.object,
    onOpen: PropTypes.func
};
